import PropTypes from 'prop-types';

export default function Participant({ alignment = 'left', children }) {
	const classes = ['blog-feedback__participant', `blog-feedback__participant--${alignment}`];
	return <div className={classes.join(' ')}>{children}</div>;
}

Participant.propTypes = {
	alignment: PropTypes.string,
	children: PropTypes.node,
};
